// src/restart/components/FeedbackSection.js
import React, { useState } from "react";
import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import "./FeedbackForm.css"; // reuse same styling if needed

const FeedbackSection = ({
  title = "GILDARC",
  text = "If you have any notes or comment, please utilize the following.",
  collectionName = "messages",
  source = "gildarc-comments",
}) => {
  const [form, setForm] = useState({ comment: "", email: "" });
  const [status, setStatus] = useState({
    loading: false,
    success: "",
    error: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, success: "", error: "" });

    try {
      if (!form.comment || !form.email) {
        throw new Error("Please include both a comment and an email.");
      }

      await addDoc(collection(db, collectionName), {
        comment: form.comment,
        email: form.email,
        createdAt: serverTimestamp(),
        source,
      });

      setStatus({
        loading: false,
        success: "Thank you — your comment has been received.",
        error: "",
      });

      setForm({ comment: "", email: "" });
    } catch (err) {
      console.error(err);
      setStatus({
        loading: false,
        success: "",
        error: err.message || "Could not save. Please try again.",
      });
    }
  };

  return (
    <div style={{ marginBottom: "50px" }}>
      <section id="cta" className="lp-section">
        <div className="pro-updates">
          
          {/* Title */}
          <h2
            className="pro-updates__title"
            style={{ textAlign: "center", marginBottom: "15px" }}
          >
            {title}
          </h2>

          {/* Description */}
          <p className="pro-updates__text">{text}</p>

          {/* Form */}
          <form onSubmit={handleSubmit}>
            {/* Comment input */}
            <div className="pro-updates__form">
              <input
                type="text"
                name="comment"
                placeholder="Enter your comments"
                className="pro-updates__input"
                value={form.comment}
                onChange={handleChange}
              />
            </div>

            {/* Email + button */}
            <div className="pro-updates__form">
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                className="pro-updates__input"
                value={form.email}
                onChange={handleChange}
                required
              />
              <button
                className="pro-updates__button"
                type="submit"
                disabled={status.loading}
              >
                {status.loading ? "Sending..." : "Notify Me"}
              </button>
            </div>
          </form>

          {/* Status messages */}
          {status.success && (
            <p
              style={{
                marginTop: "8px",
                fontSize: "0.85rem",
                color: "#16a34a",
              }}
            >
              {status.success}
            </p>
          )}

          {status.error && (
            <p
              style={{
                marginTop: "8px",
                fontSize: "0.85rem",
                color: "#dc2626",
              }}
            >
              {status.error}
            </p>
          )}
        </div>
      </section>
    </div>
  );
};

export default FeedbackSection;
